"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DashboardTimeIntervalUnits = exports.DashboardSubscriptionType = exports.DashboardEntityRelation = exports.DashboardSubscriptionEntityType = void 0;
var DashboardSubscriptionEntityType;
(function (DashboardSubscriptionEntityType) {
    DashboardSubscriptionEntityType["Task"] = "TASK";
    DashboardSubscriptionEntityType["Commit"] = "COMMIT";
    DashboardSubscriptionEntityType["PullRequest"] = "PULL_REQUEST";
})(DashboardSubscriptionEntityType = exports.DashboardSubscriptionEntityType || (exports.DashboardSubscriptionEntityType = {}));
var DashboardEntityRelation;
(function (DashboardEntityRelation) {
    DashboardEntityRelation["Tasks"] = "TASKS";
    DashboardEntityRelation["Commits"] = "COMMITS";
    DashboardEntityRelation["PullRequests"] = "PULL_REQUESTS";
})(DashboardEntityRelation = exports.DashboardEntityRelation || (exports.DashboardEntityRelation = {}));
var DashboardSubscriptionType;
(function (DashboardSubscriptionType) {
    DashboardSubscriptionType["Created"] = "CREATED";
    DashboardSubscriptionType["Updated"] = "UPDATED";
    DashboardSubscriptionType["Deleted"] = "DELETED";
    DashboardSubscriptionType["TimeInterval"] = "TIME_INTERVAL";
})(DashboardSubscriptionType = exports.DashboardSubscriptionType || (exports.DashboardSubscriptionType = {}));
var DashboardTimeIntervalUnits;
(function (DashboardTimeIntervalUnits) {
    DashboardTimeIntervalUnits["Days"] = "DAYS";
    DashboardTimeIntervalUnits["Hours"] = "HOURS";
})(DashboardTimeIntervalUnits = exports.DashboardTimeIntervalUnits || (exports.DashboardTimeIntervalUnits = {}));
//# sourceMappingURL=dashboard-insight-rule.js.map